window.Speculator = window.Speculator || {};
(function () {
  var waitForARTOv5 = function () {
    if (window.initARTOv5) {
      window.initARTOv5(window.artov5);
    } else {
      setTimeout(waitForARTOv5, 100);
    }
  };

  window.Speculator.init = () => {
    window.initARTOv5(window.artov5);
  };
})();
